 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"a67210f8a1e3787549ce","1":"5e88c7205f398094cac8","2":"be20c9e695eca9821405","3":"a7b685f4339d55486ac9","4":"68e8e5391c2d51fb63b1","5":"74ab25768617163d5440","6":"e413aabb35a1719476f3","AccountOpening":"218d1c43e141a862c4ee","BackTopBottom":"d4d2fb70b0816a9196e8","Caption":"673a3c828736d601d58f","Copyright":"74ca6e4b486947b1b0de","DataBox":"157252bdab9f668f37c3","HomeFooter":"da803e31365d578219df","Img":"ceb3ef7599d71828a7db","LivePlayer":"5e58a111318a43ee5adb","MoreTabs":"f6330dc725faea1e28c7","Nav":"efebbd2824760681424e","NormalCaption":"9fbad45cfc44e5c5a1d3","Offline":"4696d0ea5fc680a43651","QQShare":"0c6bb38006719c504725","Stick":"e1f3ac1c18493df297ed","Tip":"2dd4505f2d3b07ac9e23","ViewMoreLink":"b41ede5a6dc74834acf3","WxLaunchApp":"b46d3a94ecf9c19f6dc8","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"87b23af614a8e97141bc","Atlas":"548bbdc5954c26932039","FiveNavPic":"ace4628f9319ca8fb554","FourNavPic":"f135b6335d7b23de4a76","ThreeNavPic":"5fe8b948bbca3e1a4318","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage":"1eab3a9a20e27df8156e","Hongbao":"d235f0bd8dc5b30ae505","TwoImage":"3a86545ebb8415a75c55","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"6c31f31feaeea73bef8f","BigImage":"a1626768f7cebc07b1ac","NoImage":"18f95d2f1c6ecda72168","OneImage":"8ad0764c7b7d6b3e616c","ThreeImage":"bc386ec149467d490d7f","vendors~NewsStream":"e3acbaa809f55d9211f8","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"468b4ae864527d600482","BrowserGuideLayer":"29e598d331ff9e27202e","MarkTabs":"c886c61fa4283f604494","PageBottomBrand":"301b3c7e1474d2bccc51","WXGuideLayer":"01e1aa1e210bb9982d4b","MdBanner":"0a8d5bfb288de571f8f3","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"c75aac92849260323c13","BigImg":"be9afe5d957fc83469d0","SingleTitle":"b193824e2548a7c51e0a","SlideImg":"64273063293562b31be1","TwoImg":"6b614a503845d74ab780","vendors~BigTopic~InformationFlow~TitleImg":"4ddd522972106c191699","InformationFlow":"227a755198aab9dcbad6","BigTopic":"db6faf91c2127abc651e","TitleImg":"ce237c531240533ab82f","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"960720f66b10693117bc","vendors~BottomSlides~UpgradeBottomSlides":"e9ed1d656a0de018481a","UpgradeBottomSlides":"749f213fc9bc27ef0e90","vendors~IndexSlides":"6ba499e3be89fc9229a6","vendors~CallupHead":"1ced49dbf88207ca1e81","vendors~Comment~ShareComment":"65f6c094477b148e3839","vendors~ShareComment":"2ed8ce9ad74344d75c1d","vendors~Player":"c47f03208dd9e15324d4","vendors~Survey":"a92c4e011f5498be9125","vendors~WxLaunchHack":"6470b16f133e3dd3c21b","Slides":"b34ad0b8ef1ba7095829","vendors~NormalSlides":"ae20949d35c9d50fb9f3","vendors~ShareSlides":"1f9f55a4ae9d5943275d","vendors~CallupVideoAppHead":"b69cce30fa725e1bc1f1","vendors~Comment~LoginDialog":"97253bf022f13a997b87","LoginDialog":"095e552a02d893e29fc5","vendors~Comment":"d87e244b3e4995aa951f","Comment":"39c0ffc8a23f9c828fe8","vendors~NormalTabs":"f66ef134410d62ed37e1","vendors~SimpleGuideLayer":"a7e58cef9a68b92aa6a1","vendors~SlidesTabs":"dba854e2efb6f1cb1ab3","vendors~pics":"e6699bc1a684d7597bef","pics":"7335f6266b03a8c040a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
